/**
 * @module gorgias-chat-open
 * @description Delegates `[data-open-gorgias-chat]` clicks to Gorgias and waits for
 *   `gorgias-widget-loaded` when the widget script is still loading (matches legacy deferred init).
 */

const LOADED_EVENT = 'gorgias-widget-loaded';

/**
 * @returns {boolean} True if open was invoked
 */
function tryOpen() {
  const chat = window.GorgiasChat;
  if (chat && typeof chat.open === 'function') {
    chat.open();
    return true;
  }
  return false;
}

/**
 * Opens Gorgias chat, or subscribes once to the loaded event.
 */
export function openGorgiasChat() {
  if (tryOpen()) return;
  window.addEventListener(LOADED_EVENT, () => {
    tryOpen();
  }, { once: true });
}

document.addEventListener(
  'click',
  (e) => {
    const el = e.target.closest('[data-open-gorgias-chat]');
    if (!el) return;
    e.preventDefault();
    openGorgiasChat();
  },
  true
);
